import React from 'react';
import { Redirect, Route } from 'react-router';
import Navbar from './components/Navbar/Navbar';
import { history } from "./helpers/history";
import { useSelector } from 'react-redux';


function RouteWithLoggedIn({component:Component, ...rest}){
    const { isLoggedIn, user } = useSelector((state) => state.auth);
    const hasAuthenticatedSession = Boolean(
      isLoggedIn && user && user.accessToken
    );

   
    
    return(
        hasAuthenticatedSession ?
       <Route {...rest}>
        <Navbar history={history} />
        <Component />
       </Route>:
      <Redirect to="/auth/signin" />
      
       );
}

export default RouteWithLoggedIn;
